exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[draggable=\"true\"] {\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n\ntr[draggable=\"true\"]:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n\ntr.dragging {\n  opacity: 0.5;\n  background-color: #e3f2fd;\n}\n\ntr.drag-over {\n  border-top: 3px solid #2196F3;\n  background-color: #f5f5f5;\n}\n\n/* Avoid native text selection (shift/ctrl+click would highlight cell text in a\n   loud system blue and make it unreadable) when row selection is enabled. */\ntable.table.selectable tbody tr {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Subtle, readable highlight (translucent overlay, like the \"modified\" row) so\n   selection is visible without hiding the cell text. */\ntr.selected td {\n  background-color: rgba(56, 112, 182, 0.32) !important;\n}\n\n/* Feedback visual al copiar con doble clic */\ntd.cell-copied {\n  background-color: #c8e6c9 !important;\n  transition: background-color 0.15s ease-in-out;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/tables/sortable-table/sortable-table.component.css
// module id = ../../../../../src/app/shared/components/tables/sortable-table/sortable-table.component.css
// module chunks = main